'use strict';
import {
	JSONAPIErrorCode, JSONAPIErrorID, JSONAPIErrorLinks, JSONAPIErrorSource
} from '../interfaces/jsonapi-error-response';

export class JSONAPIError extends Error {

	constructor (message?: string) {

		super(message);
		Object.setPrototypeOf(this, new.target.prototype);

	}

}

export interface IJSONAPIErrorResponse {
	id: JSONAPIErrorID;
	links: JSONAPIErrorLinks;
	status: number;
	code: JSONAPIErrorCode;
	title: string;
	detail: string;
	source: JSONAPIErrorSource;
	meta: any;
}

export class JSONAPIErrorResponse {

	id: JSONAPIErrorID;
	links: JSONAPIErrorLinks;
	status: number;
	code: JSONAPIErrorCode;
	title: string;
	detail: string;
	source: JSONAPIErrorSource;
	meta: any;

	constructor (error: IJSONAPIErrorResponse) {
		for ( const attribute in error ) {
			this[ attribute ] = error[ attribute ];
		}
	}

}

export class JSONAPIErrorBag {

	errors: JSONAPIErrorResponse[] = [];

	constructor (errors: JSONAPIErrorResponse[]) {
		for ( const error of errors ) {
			this.errors.push(new JSONAPIErrorResponse(error));
		}
	}

	list (): JSONAPIErrorResponse[] {
		return this.errors;
	}

}
